import * as React from 'react';
import { observer } from 'mobx-react-lite';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { getNotesEditorViewState, closeNotesEditor } from 'owa-calendar-notes-editor';
import { MeetingResponseDialog } from 'owa-calendar-meeting-response-dialog';
import { cancelMeetingDialogTitleText } from './MeetingResponseDialogContainer.locstring.json';
import { logUsage } from 'owa-analytics';
import loc from 'owa-localize';
import type { ClientItemId } from 'owa-client-ids';

export interface MeetingResponseDialogContainerProps {
    itemId: ClientItemId;
    colorScheme: ColorScheme;
}

export default observer(function MeetingResponseDialogContainer(
    props: MeetingResponseDialogContainerProps
) {
    const { itemId, colorScheme } = props;
    const notesEditorViewState = itemId ? !!getNotesEditorViewState(itemId) : null;

    if (!notesEditorViewState) {
        return null;
    }

    const hideDialog = () => {
        logUsage('MeetingResponseDialogDismissed');
        closeNotesEditor(itemId);
    };

    return (
        <MeetingResponseDialog
            itemId={itemId}
            colorScheme={colorScheme}
            hideDialog={hideDialog}
            meetingDialogTitle={loc(cancelMeetingDialogTitleText)}
        />
    );
});
